import axios from 'axios';
import {
    Message
} from 'element-ui';
import initEnv from '@/utils/initEnv';
import router from '@/router';
import store from '@/store';
import Cookies from 'js-cookie';

export function getAxiosService(serviceConfig = {}) {
    serviceConfig = Object.assign({}, {
        baseURL: global.BasePath,
        timeout: 20000,
        signApiList: [],
        withoutTokenList: ['login/fromOldFramework'],
        isProcessResponse: false
    }, serviceConfig);

    const service = axios.create({
        baseURL: serviceConfig.baseURL, // api的base_url
        timeout: serviceConfig.timeout // 请求超时时间
    });

    //request拦截器
    service.interceptors.request.use(config => {
        const signApiArray = serviceConfig.signApiList;
        const withoutTokenArray = serviceConfig.withoutTokenList;
        if (!config.params) {
            config.params = new URLSearchParams();
        }
        if (!config.params.has('token') && withoutTokenArray.every(item => config.url.indexOf(item) === -1)) {
            const token = Cookies.get('Admin-Token') || sessionStorage.token;
            if (token) {
                config.params.append('token', token);
            }
        }
        return config;
    }, error => {
        // Do something with request error
        Promise.reject(error);
    });

    //response拦截器
    service.interceptors.response.use(
        response => {
            const code = response.data.code;
            // code = 200; // 成功
            // code = 400; // 访问被禁止
            // code = 403; // 访问被禁止
            // code = 404; // 资源不存在
            // code = 500; // 内部服务器错误
            // code = 1000; // 登录超时
            // code = 1001; // 不合法的参数
            // code = 1002; // 不合法的请求格式
            // code = 1003; // 不合法的请求格式
            // code = 1004; // 需要HTTPS
            // code = 1050; // 账号或密码错误
            // code = 1051; // 该用户已被禁用
            // code = 1053; // 学校异常，请联系学校管理员
            // code = 1054; // 身份不允许登录
            // code = 1056; // 该账号不存在
            if (code === -1 || code === 400 || code === 403 || code === 404 || code === 500 || code === 1000 || code === 1001 || code === 1002 || code === 1003 || code === 1004 || code === 1050 || code === 1051 || code === 1053 || code === 1054 || code === 1056) {
                Message({
                    message: response.data.msg,
                    type: 'error',
                    duration: 3 * 1000
                });
                /*yjx*/
                if (code === 1000) {
                    // 登出
                    store.dispatch('LogOut').then(res => {
                        if (window.sessionStorage.getItem('classcardManagementIsTeacher') == 1) {
                            window.location.href = global.command === 'production' ? 'http://www.zhxiaoyuan.cn/wxcepClient/toLogin' : 'http://www.weixiaojia.net/wxcepClient/toLogin';
                        } else {
                            router.push({
                                path: '/login'
                            });
                        }
                    }).catch();
                }
                return Promise.reject({
                    code: response.data.code,
                    mes: response.data.msg
                });
            } else {
                if (serviceConfig.isProcessResponse) {
                    const data = response.data;
                    if (data.result) {
                        return data.data;
                    } else {
                        Message({
                            message: data.msg,
                            type: 'error',
                            dangerouslyUseHTMLString: true
                        });
                        return Promise.reject({
                            code: data.code,
                            mes: data.msg
                        });
                    }
                } else {
                    return response;
                }
            }
        },
        error => {
            Message({
                message: error.message,
                type: 'error',
                duration: 3 * 1000,
                dangerouslyUseHTMLString: true
            });
            return Promise.reject(error);
        }
    );
    return service;
}

const fetch = getAxiosService();

export default fetch;

export const systemFetch = getAxiosService({
    baseURL: global.command === 'production' ? 'https://www.zhxiaoyuan.cn/ucenter-web/' : 'https://www.weixiaojia.net/ucenter-web/'
});
export const wymsFetch = getAxiosService({
    isProcessResponse: true,
    baseURL: global.command === 'production' ? 'https://wyms.weixiaojia.cn/wyms' : 'https://wyms.weixiaojia.net/wyms'
});
export const wymsFetchNoProcess = getAxiosService({
    baseURL: global.command === 'production' ? 'https://wyms.weixiaojia.cn/wyms' : 'https://wyms.weixiaojia.net/wyms'
});
export const resourceFetch = getAxiosService({
    isProcessResponse: true,
    baseURL: global.command === 'production' ? 'https://www.zhxiaoyuan.cn/wxcep-resource/' : 'https://www.weixiaojia.net/wxcep-resource/'
});
export const wxcepClient1Fetch = getAxiosService({
    isProcessResponse: true,
    baseURL: global.command === 'production' ? 'https://www.zhxiaoyuan.cn/wxcepClient1/' : 'https://www.weixiaojia.net/wxcepClient1/'
});

export const proFetch = getAxiosService({
    isProcessResponse: true
});
export const growthFetch = getAxiosService({
    isProcessResponse: true,
    baseURL: global.command === 'production' ? 'https://www.xjleyuan.com/growth-web/' : 'https://www.xwweixiao.com/growth-web/'
});

export function getParams(isPagination = false, args) {
    const params = new URLSearchParams();
    if (isPagination) {
        params.append('pageNo', args.pageNo);
        params.append('pageSize', args.pageSize);
    }
    return params;
}

export const newcard = getAxiosService({
    baseURL: global.command === 'production' ? 'https://www.zhxiaoyuan.cn/card/' : 'https://www.weixiaojia.net/card/'
});
//新收费专用
export const newcharge = getAxiosService({
    baseURL: global.command === 'production' ? 'https://pay.zhxiaoyuan.cn/' : 'https://pay.weixiaojia.net/'
})



// WEBPACK FOOTER //
// ./src/utils/fetch.js